import React from 'react';
import PropTypes from 'prop-types';
import Table from '$partials/global/table';
import { getColorStyles } from '$utilities/data';
import Button from '$partials/ui/button';
import { Collapsible, CollapsibleHeading, CollapsibleContextConsumer, CollapsibleContent } from '$partials/base/collapsible.jsx';
import IconArrowDown from '$partials/icons/arrow-down';
import IconArrowUp from '$partials/icons/arrow-up';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleTablesContainer = ({
    tablesCollection,
    backgroundColor,
    eyebrow,
    title,
    pdfUpload
}) => {
    const tables = tablesCollection.items;
    let bg = getColorStyles(backgroundColor);

    return (
        <div
            className={`rounded my-40 md:my-60 ${backgroundColor ? 'px-20 py-30 md:py-50 -mx-10 sm:-mx-0 md:-mx-20 md:px-40' : 'px-10 sm:px-20 pb-40'}`}
            style={{...bg}}>
            <div className='flex flex-col gap-20'>
                {eyebrow && (
                    <div className='type-style-7 text-orange '>{title}</div>
                )}
                {title && (
                    <div className='type-style-3'>{title}</div>
                )}

                {pdfUpload && (
                    <div>
                        <Button
                            as='a'
                            className='bg-orange text-white rounded type-style-7  px-20 py-15 mr-5'
                            href={`${pdfUpload.url}`}
                            target='_blank'
                            type='button'>
                            Download as PDF
                        </Button>
                    </div>
                )}
            </div>
            <div className='flex gap-20 md:mt-35 sm:mt-30 mt-40 flex-col'>
                {tables && (
                    tables.map((table, i) => {
                        let isOpened = false;

                        if(i === 0) {
                            isOpened = true;
                        }
                        return (
                            <Collapsible
                                id={'collapsible-'+ i}
                                isOpened={isOpened}
                                key={'collapsible-'+ i}>
                                <CollapsibleHeading className='w-full'>
                                    <CollapsibleContextConsumer>
                                        {({ isOpened }) => (
                                            <div className='flex justify-between'>
                                                <>
                                                    <div className='type-style-3'>
                                                        {table.title}
                                                    </div>
                                                    <div aria-hidden='true'>
                                                        {isOpened ?
                                                            <div className='p-15 bg-orange rounded aspect-square'>
                                                                <IconArrowUp />
                                                            </div> :
                                                            <div className='p-15 bg-orange rounded aspect-square'>
                                                                <IconArrowDown />
                                                            </div>}
                                                    </div>
                                                </>
                                            </div>
                                        )}
                                    </CollapsibleContextConsumer>
                                </CollapsibleHeading>
                                <CollapsibleContent>
                                    <Table
                                        backgroundColor={bg.backgroundColor}
                                        {...table} />
                                </CollapsibleContent>
                            </Collapsible>
                        );
                    })
                )}
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleTablesContainer.propTypes = {
    tablesCollection: PropTypes.object.isRequired,
    backgroundColor: PropTypes.string,
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    pdfUpload: PropTypes.object,
};

export default ModuleTablesContainer;
